class Header {
    constructor() {
        this.header = document.querySelector('.header');
        this.burger = document.querySelector('#headerBurger');
        this.nav = document.querySelector('#headerNav');
        this.bookingBtn = document.querySelector('#headerBookingBtn');
        this.bookingBtnMobile = document.querySelector('#headerBookingBtnMobile');
        this.body = document.body;
        this.bookingSection = document.querySelector('.booking');
        this.isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php' || window.location.pathname.includes('page-main');
        
        if (!this.header || !this.burger) return;
        
        this.ensureMenuClosed();
        this.init();
        this.handleInitialAnchor();
    }
    
    ensureMenuClosed() {
        this.header.classList.remove('header--menu-open');
        this.body.classList.remove('menu-open');
    }
    
    handleInitialAnchor() {
        if (window.location.hash) {
            setTimeout(() => {
                this.scrollToAnchor(window.location.hash, false);
            }, 100);
        }
    }
    
    scrollToAnchor(anchor, closeMenu = true) {
        if (!anchor || typeof anchor !== 'string') {
            return;
        }
        
        const target = document.querySelector(anchor);
        if (!target) {
            return;
        }
        
        const scrollToTarget = () => {
            const headerHeight = this.header ? this.header.offsetHeight : 0;
            const targetRect = target.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            const targetOffset = targetRect.top + scrollTop - headerHeight;
            
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            const isAndroid = /Android/.test(navigator.userAgent);
            
            if (isIOS || isAndroid) {
                let currentScroll = scrollTop;
                const distance = targetOffset - currentScroll;
                const duration = 500;
                const startTime = Date.now();
                
                const easeInOutQuad = (t) => {
                    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                };
                
                const animateScroll = () => {
                    const elapsed = Date.now() - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const eased = easeInOutQuad(progress);
                    
                    currentScroll = scrollTop + (distance * eased);
                    window.scrollTo(0, currentScroll);
                    
                    if (progress < 1) {
                        requestAnimationFrame(animateScroll);
                    } else {
                        window.scrollTo(0, targetOffset);
                    }
                };
                
                requestAnimationFrame(animateScroll);
            } else {
                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            }
        };
        
        if (closeMenu && window.innerWidth <= 1024) {
            this.closeMenu();
            setTimeout(() => {
                scrollToTarget();
            }, 350);
        } else {
            setTimeout(() => {
                scrollToTarget();
            }, 50);
        }
    }
    
    scrollToBooking() {
        if (this.isHomePage) {
            if (this.bookingSection) {
                this.scrollToAnchor('#booking', false);
            }
        } else {
            window.location.href = homeUrl + '#booking';
        }
    }
    
    init() {
        this.burger.addEventListener('click', () => this.toggleMenu());
        
        this.nav.addEventListener('click', (e) => {
            const link = e.target.closest('.header__menu-link');
            if (link) {
                e.preventDefault();
                
                const href = link.getAttribute('href');
                const anchor = link.getAttribute('data-anchor') || (href && href.includes('#') ? '#' + href.split('#')[1] : '');
                
                if (anchor) {
                    if (this.isHomePage) {
                        this.scrollToAnchor(anchor, true);
                    } else {
                        window.location.href = homeUrl.replace(/\/$/, '') + anchor;
                    }
                } else if (href && !href.startsWith('#')) {
                    if (window.innerWidth <= 1024) {
                        this.closeMenu();
                    }
                    window.location.href = href;
                }
            }
        });
        
        document.addEventListener('click', (e) => {
            if (window.innerWidth <= 1024 && this.header.classList.contains('header--menu-open')) {
                if (!this.header.contains(e.target) && !e.target.closest('.header')) {
                    this.closeMenu();
                }
            }
        });
        
        window.addEventListener('resize', () => {
            if (window.innerWidth > 1024) {
                const bookingModal = document.getElementById('bookingModal');
                const certificateModal = document.getElementById('certificateModal');
                const isModalOpen = (bookingModal && bookingModal.classList.contains('booking-modal--active')) || 
                                   (certificateModal && certificateModal.classList.contains('booking-modal--active'));
                
                if (!isModalOpen) {
                    this.closeMenu();
                }
            }
        });
        
        if (this.bookingBtn) {
            this.bookingBtn.addEventListener('click', () => {
                this.scrollToBooking();
            });
        }
        
        if (this.bookingBtnMobile) {
            this.bookingBtnMobile.addEventListener('click', () => {
                this.closeMenu();
                setTimeout(() => {
                    this.scrollToBooking();
                }, 300);
            });
        }
        
        const heroBtnGroup = document.querySelector('.hero__btn-group');
        if (heroBtnGroup) {
            heroBtnGroup.addEventListener('click', (e) => {
                const link = e.target.closest('a[href^="#"]');
                if (link) {
                    e.preventDefault();
                    const href = link.getAttribute('href');
                    if (href && href.startsWith('#')) {
                        this.scrollToAnchor(href, false);
                    }
                }
            });
        }
    }
    
    toggleMenu() {
        if (this.header.classList.contains('header--menu-open')) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }
    
    openMenu() {
        this.header.classList.add('header--menu-open');
        this.body.classList.add('menu-open');
    }
    
    closeMenu() {
        if (!this.header.classList.contains('header--menu-open')) {
            return;
        }
        
        const nav = this.nav;
        const burgerLines = this.burger ? this.burger.querySelectorAll('.header__burger-line') : [];
        
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.header.classList.remove('header--menu-open');
                
                const handleTransitionEnd = () => {
                    this.body.classList.remove('menu-open');
                    
                    if (nav) {
                        nav.removeEventListener('transitionend', handleTransitionEnd);
                        nav.removeEventListener('webkitTransitionEnd', handleTransitionEnd);
                    }
                };
                
                if (nav) {
                    nav.addEventListener('transitionend', handleTransitionEnd, { once: true });
                    nav.addEventListener('webkitTransitionEnd', handleTransitionEnd, { once: true });
                    
                    setTimeout(() => {
                        handleTransitionEnd();
                    }, 350);
                } else {
                    setTimeout(() => {
                        this.body.classList.remove('menu-open');
                    }, 300);
                }
            });
        });
    }
    
}

const homeUrl = window.location.origin + '/';

export default function initHeader() {
    new Header();
}

